import TableBodyRow from "ds/components/Table/Row";
import TableCell from "ds/components/Table/Row/Cell";
import TableSkeletonItem from "ds/components/Table/Skeleton/Item";

type TableSkeletonRowProps = {
  columnIds: string[];
};

const TableSkeletonRow = ({ columnIds }: TableSkeletonRowProps) => {
  return (
    <TableBodyRow>
      {columnIds.map((column) => (
        <TableCell key={column} direction="column">
          <TableSkeletonItem />
        </TableCell>
      ))}
    </TableBodyRow>
  );
};

TableSkeletonRow.displayName = "DS.Table.Skeleton.Row";

export default TableSkeletonRow;
